// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"88db483f","405":"9b8e7e33","697":"454a81bb","766":"b45bcea4","829":"9cfe2dec","892":"283c1b02"}[chunkId] + ".chunk.js";
};